import { useState } from "react";
import styles from "../FaqSection/FaqSection.module.css";
import TitleBar from "../../TitleBar/TitleBar";
const FaqSection = ({ fetchFaq = {} }) => {
  console.log(fetchFaq,"fetchFaq")
  const title = fetchFaq?.title || "Frequently Asked Questions";
  const intro =
    fetchFaq?.intro ||
    "We understand that starting something new can bring questions. Here are some of the most common inquiries about our AI receptionist.";

  const avatars =
    (fetchFaq?.avatars || []).map((a) => ({
      src: a?.image?.src || "",
      alt: a?.image?.alt || "avatar",
    })) || [];

  const metric = fetchFaq?.metric || {};
  const faqs = fetchFaq?.faqs || [];

  console.log(metric,"metric of FAQ page")

  const renderMetricValue = (value) => {
    if (!value) {
      return (
        <>
          3 M<span className={styles.plus}>+</span>
        </>
      );
    }
    const str = String(value);
    const hasPlus = str.trim().endsWith("+");
    const base = hasPlus ? str.trim().slice(0, -1) : str;
    return (
      <>
        {base}
        {hasPlus && <span className={styles.plus}>+</span>}
      </>
    );
  };

  const [activeIndex, setActiveIndex] = useState(faqs.length ? 0 : null);
  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  if (fetchFaq?.enabled === false || faqs.length === 0) return null;

  return (
    <div className={styles.containerBox}>
      <div className={styles.container}>
        {/* Left */}
        <div className={styles.LeftSection}>
          <div className={styles.contentDiv}>
            <TitleBar blocks={title} marginBlock="0px 2.5rem" />
            {/* <p>{intro}</p> */}

            <div className={styles.container2}>
              {/* Avatars */}
              <div className={styles.imageGroup}>
                {avatars.map((img, i) => (
                  <div className={styles.avatar} key={img.src || i}>
                    <img src={img.src} alt={img.alt} />
                  </div>
                ))}
              </div>

              {/* Metric */}
              <div className={styles.textSection}>
                <h2>{metric.displayValue}</h2>
                <p>{metric.label || "Happy customer"}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Right */}
        <div className={styles.RightSection}>
          <div className={styles.accordion}>
            {faqs.map((item, index) => (
              <div
                key={item.id || index}
                className={`${styles.item} ${
                  activeIndex === index ? styles.active : ""
                }`}
              >
                <div
                  className={styles.titleRow}
                  onClick={() => toggleAccordion(index)}
                >
                  <h3 className={styles.question}>{item.question}</h3>
                  <span className={styles.icon}>
                    {activeIndex === index ? "−" : "+"}
                  </span>
                </div>

                <div
                  className={`${styles.contentWrapper} ${
                    activeIndex === index ? styles.open : ""
                  }`}
                >
                  <p className={styles.content}>{item.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        {/* /Right */}
      </div>
    </div>
  );
};

export default FaqSection;
